<template>
  <div>
    <div class="save-box">
      <div class="save-text-wrap">
        <p>2023년까지 SSGPAY에서 구매하신 잔액관리형 쿠폰 목록입니다.</p>
      </div>
      <div v-if="emarticonList.length === 0" class="save-not-coupon">
        <em class="icon-round-tooltip"></em>
        <span>사용가능한 잔액관리형 쿠폰이 없습니다.</span>
      </div>
      <div v-if="emarticonList.length !== 0" class="save-info">
        <span>총 <em>{{ totalCount }}</em>개</span>
      </div>
    </div>

    <ul v-if="emarticonList.length !== 0" class="save-list">
      <li v-for="card in emarticonList" class="save-item" v-if="card.status === 'U'" @click="toggleBarcodePopup(card)">
        <div class="save-item-left">
          <a href="javascript:void(0);">
            <div class="item-image card-image" :style="{ backgroundImage:'url('+card.imgUrl+')'}"></div>
          </a>
        </div>
        <div class="save-item-right">
          <div class="save-item-birth">
            <span>{{card.prdtNm !== null? card.prdtNm : ''}}</span>
          </div>
          <div class="save-item-price">
            <a href="javascript:void(0);">
              <strong>{{ Number(card.remainAmt).toLocaleString() }}</strong>
              <br>
              <span v-if="card.periodEnd !== null">~{{ card.periodEnd }}</span>
              <div>
                <em>사용가능</em>
              </div>
            </a>
          </div>
          <div class="save-item-line"></div>
        </div>
      </li>
    </ul>
<!--    <div class="use-box-wrap">-->
<!--      <ul>-->
<!--        <li class="use-box-item" tabindex="0">-->
<!--          <div class="use-item-left"><span class="icon-guide"></span><span class="use-item-text">이용방법 안내</span></div>&lt;!&ndash; TODO 라우팅 추가 &ndash;&gt;-->
<!--          <button @click="$router.push({name:''})"><span class="icon-chevron-right"></span></button>-->
<!--        </li>-->
<!--        <li class="use-box-item" tabindex="0">-->
<!--          <div class="use-item-left"><span class="icon-product-notice"></span><span class="use-item-text">상품고지</span></div>&lt;!&ndash; TODO 라우팅 추가 &ndash;&gt;-->
<!--          <button @click="$router.push({name:''})"><span class="icon-chevron-right"></span></button>-->
<!--        </li>-->
<!--      </ul>-->
<!--    </div>-->
<!--    <gray-line></gray-line>-->
<!--    <div class="save-precautions">-->
<!--      <div>-->
<!--        <span class="icon-tool-tip"></span>-->
<!--        <strong>구 이마티콘 유의사항</strong>-->
<!--      </div>-->
<!--      <ul>-->
<!--        <li>-->
<!--          <p>∙<em>본 잔액관리형 쿠폰은 종료된 서비스로 추가 충전이 불가능합니다.</em></p>-->
<!--        </li>-->
<!--        <li>-->
<!--          <p>∙<em>해당 카드 사용 후에, 새로운 이마티콘 서비스를 이용해주세요.</em></p>-->
<!--        </li>-->
<!--      </ul>-->
<!--    </div>-->
    <gray-line></gray-line>
    <div class="save-precautions">
      <div>
        <span class="icon-tool-tip"></span>
        <strong>유의사항</strong>
      </div>
      <ul>
        <li>
          <p>∙ <em>23년 이전에 구매하신 이마티콘으로 동일하게 사용하실수 있습니다.</em></p>
        </li>
        <li>
          <p>∙ <em>사용방법<br>
            이마티콘 -> 카드보관함 -> 2024년 1월까지 구매한 아미티콘 -> 사용가능한 이마티콘 선택후 이마트 계산대에서 사용</em></p>
        </li>
        <li>
          <p>∙ <em>보유하신 이마티콘의 유효기간이 지났을 경우 아래 SSGPAY 고객센터로 환불 받으시기 바랍니다.<br>
            &lt;SSGPAY 고객센터 : 1644-1133&gt;</em></p>
        </li>
        <li>
          <p>∙ <em>해당 이마티콘은 추가 충전이 불가하며, 사용후에는 신규 충전형 이마티콘 서비스를 이용해 주세요.</em></p>
        </li>
      </ul>
    </div>
    <gray-line></gray-line>
    <div class="save-precautions">
      <div>
        <span class="icon-tool-tip"></span>
        <strong>상품 고시정보</strong>
      </div>
      <ul>
        <li>
          <p>∙ <em>발행자<br>
            ㈜ 에스에스지닷컴</em></p>
        </li>
        <li>
          <p>∙ <em>유효기간<br>
            발행일로부터 366일( 힐안 판매 상품의 경우 유효기간이 상이할수 있습니다.)</em></p>
        </li>
        <li>
          <p>∙ <em>이용조건<br>
            유효기간 이내 사용 가능하며, 유효기간 만료시에는 기간 연장이 불가합니다.<br>
            유효기간 연장은 만료 30일 전부터 신청 가능합니다.<br>
            최초 유효기간 연장 신청 시 유효기간 연장이 가능합니다.<br>
            유효기간 만료 30일 전부터 연장 신청 가능하며, 1회 연장시 92일씩 최대 5년까지 연장 가능합니다.<br>
            상품 상세 페이지에서 유효기간 연장이 불가한 상품임을 사전에 안내한 경우 해당 상품의 유효기간 연장이 불가합니다.<br>
            할인 판매 상품 및 프로모션 연계 상품 , 무상제공 상품의 경우 유효기간 연장 정책이 일반 상품과 상이할 수 있습니다.<br>
            미사용하였으나 유효기간이 만료되었을 경우 , 미사용 이마티콘 환불 규정에 따라 환불 요청이 가능합니다.(수수료 발생)</em></p>
        </li>
        <li>
          <p>∙ <em>지급보증<br>
            본 교환권은 지급보증 및 피해보상보험 계약없이  ㈜ 에스에스이지닷컴의 신용으로 발행됩니다.</em></p>
        </li>
        <li>
          <p>∙ <em>소비자 상담 전화번호<br>
            1644-1133</em></p>
        </li>
      </ul>
    </div>
    <emarticon-barcode v-if="showBarcode" :barcodeInfo="barcodeInfo" @toggleBarcodePopup="toggleBarcodePopup"></emarticon-barcode>
  </div>
</template>

<script>
import apiList from "@/api/apiList";
import GrayLine from "@/components/common/GrayLine";
import EmarticonBarcode from '@/views/home/emarticonBarcode.vue';

export default {
  name: "EmarticonBefore2023",
  components: { GrayLine, EmarticonBarcode },
  data() {
    return {
      emarticonList: [],
      totalCount: 0,
      showBarcode: false,
      barcodeInfo: {},
    }
  },
  mounted() {
    this.$heading('카드 보관함');
    this.getPrepaidCardBefore2023();
  },
  methods: {
    async getPrepaidCardBefore2023() {
      try {
        const res = await apiList.getSsgPayEmarticon();
        this.emarticonList = res.data.data.ematiconList;
        this.totalCount = res.data.data.totalCount;
        this.dateFormat();
      } catch (error) {
        console.error(error);
      }
    },
    dateFormat() {
      for(let card of this.emarticonList) {
        if(card.periodEnd !== '') {
          let formatted = card.periodEnd.substring(0,4) + '-' + card.periodEnd.substring(4,6) + '-' + card.periodEnd.substring(6,8);
          card.periodEnd = formatted;
        }
      }
    },
    toggleBarcodePopup(barcodeInfo) {
      this.showBarcode = !this.showBarcode;
      if(this.showBarcode){
        this.barcodeInfo.prepaidCardNo = barcodeInfo.cpnNo;
        this.barcodeInfo.remainCash = barcodeInfo.remainAmt;
        this.barcodeInfo.showBottons = false;
      }
    },
  }
}
</script>

<style lang="scss" scoped>
  @import '@/assets/styles/pages/myemarticon/saveBox.scss';
</style>